export default {"src":"/_next/static/media/0x68f180fcce6836688e9084f035309e29bf0a2095.684ff353.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};